import { Pipe, PipeTransform } from '@angular/core';
import {
  IMetadataTicketDetailsResponse,
  IHQTicketDetailsResponse,
  TicketingVersion,
} from '../models';

@Pipe({
  name: 'ticketTitle',
  standalone: true,
})
export class TicketTitlePipe implements PipeTransform {
  transform(
    details: IHQTicketDetailsResponse | IMetadataTicketDetailsResponse,
    version: TicketingVersion
  ): string {
    if (!details) {
      return null;
    }
    if (version === TicketingVersion.HIERARCHICAL) {
      return (details as IHQTicketDetailsResponse).category?.name;
    } else if (version === TicketingVersion.METADATA) {
      return (details as IMetadataTicketDetailsResponse).title;
    } else {
      return null;
    }
  }
}
